/**
 * getImageQuality — assess image suitability based on width.
 *
 * Now context-aware via ImageIntent. Uses central thresholds.
 */

import { type ImageIntent, getIntentThresholds } from '@/lib/media/imageIntent';

export type ImageQuality = 'good' | 'ok' | 'low';

export interface ImageQualityResult {
  quality: ImageQuality;
  label: string;
  width: number | null;
}

export function getImageQuality(
  width: number | null | undefined,
  /** Image intent — required, no silent hero default. */
  intent: ImageIntent,
): ImageQualityResult {
  const thresholds = getIntentThresholds(intent);

  const QUALITY_LABELS: Record<ImageQuality, string> = {
    good: 'Bra bild',
    ok: 'Kan förbättras',
    low: 'För liten bild',
  };

  if (width == null) {
    return { quality: 'low', label: QUALITY_LABELS.low, width: null };
  }
  if (width >= thresholds.goodWidth) {
    return { quality: 'good', label: QUALITY_LABELS.good, width };
  }
  if (width >= thresholds.warnWidth) {
    return { quality: 'ok', label: QUALITY_LABELS.ok, width };
  }
  return { quality: 'low', label: QUALITY_LABELS.low, width };
}

/** Map ImageQuality to StudioStatusCard status */
export function qualityToCardStatus(q: ImageQuality): 'done' | 'partial' | 'missing' {
  if (q === 'good') return 'done';
  if (q === 'ok') return 'partial';
  return 'missing';
}
